import * as yup from 'yup';
import * as Constants from './constants';

export const ValidationSchema = yup.object().shape({
  username: yup.string().required('User name required'),
  password: yup
    .string()
    .required('Password required'),
});
